<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import lang from './lang.vue'
import { useI18n } from 'vue-i18n'
import { useIndexStore } from '@/store'
import { showToast } from 'vant'
import tg from '@/assets/icon/public/tg.png'
import twitter from '@/assets/icon/public/twitter.png'
import github from '@/assets/icon/public/github.png'
import logo from '@/assets/icon/public/logo.png'
import en from '@/assets/icon/en.png'
import zh from '@/assets/icon/zh.png'
import ztwh from '@/assets/icon/tw.png'
import { formatEthereumAddress } from '@/utils'
const emit = defineEmits(['connectWallet'])
defineProps({
  theme: {
    type: String,
    default: 'light' //'dark' // light
  },
  showTips: {
    type: Boolean,
    default: false
  }
})
const { t } = useI18n()
const store = useIndexStore()
let langRef = ref(null)
let show = ref(false)
const openOrCloseEnd = ref(false)
const router = useRouter()
const route = useRoute()

let handleLanguge = () => {
  langRef.value.open()
}
let connectWallet = () => {
  emit('connectWallet')
}
let navListBase = ref([
  {
    label: '首页',
    path: '/index',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>`
  },
  {
    label: '我的钱包',
    path: '/wallet',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>`
  },
  {
    label: '我的社区',
    path: '/community',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>`
  },
  // {
  //   label: 'LP生态',
  //   path: '/pgt',
  //   turnon: true,
  //   icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1v22"></path><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>`
  // },
  {
    label: '充值释放',
    path: '/dorecharge',
    turnon: false,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>`
  },
  {
    label: '创世节点',
    path: '/node',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2"></circle><circle cx="12" cy="5" r="2"></circle><circle cx="12" cy="19" r="2"></circle><circle cx="5" cy="12" r="2"></circle><circle cx="19" cy="12" r="2"></circle><line x1="12" y1="7" x2="12" y2="10"></line><line x1="12" y1="14" x2="12" y2="17"></line><line x1="7" y1="12" x2="10" y2="12"></line><line x1="14" y1="12" x2="17" y2="12"></line></svg>`
  },
  {
    label: '超级共识',
    path: '/super-consensus',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 2.2 4.46 4.92.72-3.56 3.47.84 4.9L12 14.24l-4.4 2.31.84-4.9-3.56-3.47 4.92-.72L12 3Z"></path><path d="M5 21h14"></path></svg>`
  },
  {
    label: '互助中心',
    path: '/activity-center',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect x="3" y="4" width="18" height="18" rx="2"></rect><path d="M3 10h18"></path><path d="m9 16 2 2 4-4"></path></svg>`
  },
  {
    label: '游戏托管',
    path: '/game-hosting',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path><circle cx="12" cy="16" r="1"></circle></svg>`
  },
  // {
  //   label: '质押',
  //   path: '/stake',
  //   turnon: true,
  //   icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path><circle cx="12" cy="16" r="1"></circle></svg>`
  // },
  {
    label: '游戏中心',
    path: '/game-center',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>`
  },
  {
    label: '墟界求生',
    path: '/game',
    turnon: true,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline></svg>`
  },
  {
    label: '释放',
    path: '/release',
    turnon: false,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>`,
    showCondition: () => store.userInfo?.liberate && Object.keys(store.userInfo.liberate).length > 0
  }
])

// 根据条件过滤菜单列表
const navList = computed(() => {
  return navListBase.value.filter(item => {
    if (item.showCondition) {
      return item.showCondition()
    }
    return true
  })
})
  // {
  //   label: 'LON映射',
  //   path: '/mapping',
  //   icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>`
  // }
// ])

const changeMeun = () => {
  show.value = !show.value
}

const handleClick = (item) => {
  if (!item.turnon) {
    showToast('敬请期待~')
    return
  }
  if (item.comingSoon && store.userInfo?.dud !== 1) {
    showToast('敬请期待~')
    return
  }
  if (route.path !== item.path) {
    router.push({ path: item.path })
  }
  changeMeun()
}
const toHome = () => {
  router.push({ path: '/index' })
  show.value = false
}
// 关闭结束
const handleClosed = () => {
  openOrCloseEnd.value = false
}
// 打开结束
const handleOpened = () => {
  openOrCloseEnd.value = true
}
</script>
<template>
  <nav :class="[showTips && !show ? 'mb-66' : '']">
    <div class="flex justify-between items-center w-100%">
      <div class="left flex items-center gap-26">
        <van-image width="34" height="34" :src="logo" @click="changeMeun" />
        <div class="">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 44 44" fill="none">
            <path
              d="M22 5.83945C22.4555 5.83945 22.898 5.87812 23.3363 5.94687C23.4051 5.775 23.448 5.59023 23.448 5.39687C23.448 4.59766 22.7992 3.95312 22.0043 3.95312C21.2051 3.95312 20.5605 4.60195 20.5605 5.39687C20.5605 5.59023 20.5992 5.7793 20.6723 5.94687C21.102 5.87812 21.5445 5.83945 22 5.83945ZM22 34.2375H17.0715C17.0285 34.5039 16.9984 34.7703 16.9984 35.0496C16.9984 37.8125 19.2371 40.0512 22 40.0512C24.7629 40.0512 27.0016 37.8125 27.0016 35.0496C27.0016 34.7746 26.9715 34.5039 26.9285 34.2375H22Z"
              fill="#455476" />
            <path
              d="M34.5512 29.6012C32.8539 29.6012 32.2609 28.2648 32.2609 26.2797C32.2609 25.502 32.102 15.2023 32.102 15.2023C32.102 10.3168 27.5473 6.10587 22 6.10587C16.4527 6.10587 11.898 10.3168 11.898 15.2023C11.898 15.2023 11.7391 25.4977 11.7391 26.2797C11.7391 28.2648 11.1461 29.6012 9.44883 29.6012C7.82461 29.6012 6.99531 30.3445 6.99531 31.7238C6.99531 32.8926 8.09961 33.8465 9.44883 33.8465H34.5512C35.9004 33.8465 37.0047 32.8926 37.0047 31.7238C37.0047 30.3445 36.1754 29.6012 34.5512 29.6012Z"
              fill="#455476" />
          </svg>
        </div>
        <van-image width="22" height="22" :src="zh" @click="handleLanguge" />
      </div>
      <div class="right flex justify-between items-center" @click="connectWallet" v-if="!store.address">
        <div class="nav-connect-btn van-haptics-feedback">
          Connect Wallet
        </div>
      </div>
      <div class="right flex justify-between items-center" v-else>
        <div class="nav-connect-btn van-haptics-feedback">
          {{ formatEthereumAddress(store.address) }}
        </div>
      </div>
    </div>
    <div
      class="w-100% h-66 absolute left-0 bottom-[-66px] bg-[#FFFFFF] pl-32px text-[#707070] text-[24px] font-pingfang font-400 line-height-[66px]"
      v-show="!show ? (!openOrCloseEnd && showTips) : (!show && showTips)">CAW 0.0723045(-2.26%)VVS 0.05
    </div>
  </nav>
  <lang ref="langRef" />
  <van-popup v-model:show="show" z-index="9" :overlay="true" position="left" @closed="handleClosed"
    @opened="handleOpened" :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }">
    <div class="nav_body">
      <!-- Logo和关闭按钮区域 -->
      <div class="nav_header">
        <van-image width="48" height="48" :src="logo" />
        <div class="close_btn" @click="changeMeun">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
      </div>

      <!-- 菜单列表 -->
      <div class="nav_list">
        <div 
          class="nav_list_item" 
          :class="{ 'active': route.path === item.path }"
          v-for="item in navList" 
          v-show="item.turnon !== false"
          :key="item.label" 
          @click="handleClick(item)"
        >
          <div class="nav_list_item--icon-left" v-html="item.icon"></div>
          <div class="nav_list_item--label">{{ item.label }}</div>
          <div class="nav_list_item--arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </div>
      </div>

      <!-- 底部装饰 -->
      <div class="nav_footer">
        <div class="decoration_line"></div>
        <div class="footer_text">Web3 Mining Platform</div>
      </div>
    </div>
  </van-popup>
</template>

<style scoped lang="scss">
nav {
  position: relative !important;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 146px;
  padding: 44px 30px;
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 99;
  background-color: #FFFFFF;
  backdrop-filter: blur(10px);
  // margin-bottom: 66px;
}

.account {
  color: #000;
  text-align: center;
  font-family: MiSans;
  font-size: 12px;
  font-style: normal;
  font-weight: 630;
  line-height: normal;
  margin-left: 12px;
  margin-right: 20px;
}

.nav_btn {
  margin-left: 16px;
}

.nav_body {
  width: 85vw;
  max-width: 600px;
  height: 100vh;
  position: relative;
  background: linear-gradient(165deg, #001845 0%, #001233 50%, #000814 100%);
  padding: 44px 0 40px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  // 背景装饰
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at 30% 50%, rgba(0, 193, 255, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(0, 193, 255, 0.3) 50%, transparent 100%);
  }
}

.nav_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;

  .close_btn {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    cursor: pointer;
    transition: all 0.3s ease;

    svg {
      color: #00C1FF;
    }

    &:active {
      transform: scale(0.95);
      background: rgba(255, 255, 255, 0.12);
    }
  }
}

.nav_list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 0 20px;
  position: relative;
  z-index: 1;

  .nav_list_item {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(10px);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    // 悬停光效
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(0, 193, 255, 0.1), transparent);
      transition: left 0.5s ease;
    }

    &:active {
      transform: translateX(4px);
    }

    &.active {
      background: linear-gradient(135deg, rgba(0, 193, 255, 0.15) 0%, rgba(0, 84, 211, 0.08) 100%);
      border-color: rgba(0, 193, 255, 0.3);
      box-shadow: 0 4px 20px rgba(0, 193, 255, 0.15);

      .nav_list_item--icon-left {
        color: #00C1FF;
      }

      .nav_list_item--label {
        color: #00C1FF;
      }

      .nav_list_item--arrow {
        color: #00C1FF;
      }
    }

    &:hover::before {
      left: 100%;
    }

    .nav_list_item--icon-left {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
      margin-right: 16px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.06);
      color: #9DABC4;
      transition: all 0.3s ease;
    }

    .nav_list_item--label {
      flex: 1;
      color: #FFFFFF;
      font-family: MiSans, PingFang SC, sans-serif;
      font-size: 28px;
      font-weight: 500;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
    }

    .nav_list_item--arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9DABC4;
      opacity: 0.6;
      transition: all 0.3s ease;
    }

    &:active .nav_list_item--arrow {
      transform: translateX(4px);
    }
  }
}

.nav_footer {
  padding: 30px 30px 0;
  position: relative;
  z-index: 1;

  .decoration_line {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(0, 193, 255, 0.3) 50%, transparent 100%);
    margin-bottom: 20px;
  }

  .footer_text {
    text-align: center;
    color: rgba(255, 255, 255, 0.4);
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: 300;
    letter-spacing: 1px;
  }
}

.nav-connect-btn {
  background: linear-gradient(180deg, #00C1FF 0%, #0054D3 100%);
  border-radius: 20px;
  padding: 16px 32px;
  font-size: 22px;
  color: #FFFFFF;
  font-family: Roboto;
  font-weight: 400;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.border-c18 {
  border: 1px solid #00C18D;
}
</style>
